/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useContext } from "react";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import PriorAuthorizationContext from "../../../../../contexts/PriorAuthorization/PriorAuthorization.context";
import { apiStatus } from "../../../../../shared/enums";
import Loading from "../../../../../components/Loading";

const AutoCompleteInput = ({
  name,
  onChange,
  value,
  tProps,
  size = "small",
  width = "50ch",
}) => {
  const [inputValue, setInputValue] = useState("");
  const [textValue, setTextValue] = useState("");
  const [options, setOptions] = useState([]);

  const {
    create: {
      status,
      getRecords,
      disableNext,
      enableNext,
      data: drugList,
      steps,
    },
  } = useContext(PriorAuthorizationContext);

  const onUpdate = (e, value) => {
    onChange({ target: { name, value } });
    setInputValue(value);
  };

  const onInputChange = (e) => {
    if (e && e.target) {
      setTextValue(e.target.value);
    }
  };
  // !Note: I don't see any reason why we are using this logic

  useEffect(() => {
    disableNext()
    if (!drugList || !drugList.length) {
      getRecords();
    }
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (drugList && textValue && textValue.length > 2) {
      setOptions(
        drugList.map((drug) => {
          if (drug.drugLabelName.toLowerCase().startsWith(textValue.toLowerCase())) {
            return drug.drugLabelName;
          }
          return "";
        })
      );
    } else {
      setOptions([]);
    }
    // eslint-disable-next-line
  }, [textValue]);
  useEffect(() => {
    if(steps[2].isValid && inputValue !== null && inputValue !== "") {
      enableNext();
    } else {
      disableNext();
    }
  },[steps[2].isValid])
  useEffect(() => {
    enableNext();
  }, [steps[2].completed === true]);
  return (
    <>
      {status === apiStatus.LOADING && <Loading />}
      <Autocomplete
        value={value || ""}
        freeSolo
        onChange={onUpdate}
        onInputChange={onInputChange}
        id="MEDCAL_RX_AUTOCOMPLETE"
        options={options}
        getOptionLabel={(option) => option}
        size={size}
        aria-label="Drug List"
        renderInput={(params) => (
          <TextField
            {...params}
            {...tProps}
            variant="outlined"
            value={inputValue}
            style={{ width }}
            name={name}
          />
        )}
      />
    </>
  );
};

export default AutoCompleteInput;
